<main id="main-content" class="h-screen flex flex-col pl-10 py-4 pr-4 transition-all duration-0">
    <div class="w-full flex flex-col p-2 items-center gap-2">
        <div class="w-full flex flex-row items-center justify-between">
            <div class="w-full flex gap-2 items-center justify-start">
                <h1 class="oswald-font text-3xl uppercase">
                    Number of Student, Staff, Rooms
                </h1>
                <div data-popover-target="popover-bottom" data-popover-placement="bottom" type="button">
                    <lucide-icon [name]="icons.CircleHelp" [size]=24 class="text-red-500"></lucide-icon>
                </div>
                <div data-popover id="popover-bottom" role="tooltip"
                    class="absolute z-30 invisible inline-block w-fit max-w-[600px] text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-md shadow-xs opacity-0">
                    <div class="px-3 py-2">
                        <p>
                            Select a document on the left, then fill out the counts. Click
                            <span class="inline-flex px-3.5 py-1 flex items-center justify-center text-white oswald-font bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 rounded-md">Save</span>
                            when complete.
                        </p>
                    </div>
                    <div data-popper-arrow></div>
                </div>
            </div>
        </div>
    </div>

    <!-- MAIN CONTENT -->
    <div class="p-2 w-full flex flex-grow gap-8 items-start overflow-y-auto">
        <div class="w-1/3 max-h-full bg-white rounded-md shadow-custom-2 p-6 flex flex-col gap-4">
            <div class="flex flex-row w-full items-center justify-between">
                <h2 class="oswald-font text-3xl font-medium">DOCUMENT</h2>
            </div>
            <div class="h-full w-full flex flex-wrap text-gray-900 overflow-y-auto">
                <div class="h-full w-full mr-2 flex flex-col gap-2">
                    <div class="w-full flex flex-row items-stretch gap-2" *ngFor="let section of sections">
                        <button
                            class="min-h-10 flex-1 px-2.5 py-1.5 flex flex-row gap-2 items-center justify-between rounded-md hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200 hover:text-white hover:border-nside-orange-100 group"
                            [ngClass]="{
                                'bg-gray-50 border border-nside-gray-300': selectedSection !== section,
                                'bg-gradient-to-b from-nside-orange-100 to-nside-orange-200 text-white border-nside-orange-100': selectedSection === section
                                }" (click)="$event.preventDefault(); selectSection(section);">
                            <span class="text-start">{{ section }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <form #countsForm="ngForm" (ngSubmit)="onSubmit()"
            class="w-2/3 max-h-full bg-white rounded-md shadow-custom-2 p-6 flex flex-col flex-grow gap-4 overflow-y-auto">
            <h2 class="oswald-font text-3xl text-nside-orange-400">{{ this.selectedSection }}</h2>
            <div class="w-full h-full overflow-y-auto flex flex-col flex-grow gap-4 overflow-y-auto">
                <div *ngIf="data && sectionFields[selectedSection] as fields"
                    class="flex flex-col px-1 divide-y divide-gray-200">
                    <div *ngFor="let field of fields" class="flex flex-row items-center gap-4 py-1">
                        <span class="flex-1" [ngClass]="{ 'font-semibold': isTotalKey(field.key) }">{{ field.label }}</span>
                        <input *ngIf="canSave()" type="text" [name]="field.key" [(ngModel)]="data[field.key]"
                            (ngModelChange)="isTotalKey(field.key) ? onTotalEdit(selectedSection) : onRowChange(selectedSection)"
                            class="w-40 shrink-0 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded p-1.5"
                            placeholder="Enter here">
                        <p *ngIf="!canSave()" class="w-40 shrink-0 p-1.5 text-sm whitespace-pre-line break-words"
                            [ngClass]="(data[field.key] !== null && data[field.key] !== undefined && data[field.key] !== '') ? 'text-gray-900' : 'text-gray-400 italic'">
                            {{ (data[field.key] !== null && data[field.key] !== undefined && data[field.key] !== '') ? data[field.key] : 'Empty' }}
                        </p>
                    </div>
                </div>
            </div>
            <div class="w-full flex flex-row gap-2 items-center justify-between">
                <div *ngIf="data.last_updated_at" class="flex flex-col items-start">
                    <p class="oswald-font font-normal">
                        Last Updated At: <span class="raleway-font">{{ data.last_updated_at | date: 'MM/dd/yyyy - HH:mm' }}</span>
                    </p>
                    <p class="oswald-font font-normal">
                        By: <span class="raleway-font">{{ data.last_updated_user_name || 'None' }}</span>
                    </p>
                </div>
                <button *ngIf="canSave()"
                    class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white ml-auto border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200"
                    (click)="$event.preventDefault(); onSubmit()">
                    Save
                </button>
            </div>
        </form>
    </div>
    <prv-next-buttons></prv-next-buttons>
</main>

<introduction></introduction>

<popup-message [type]="messageModal" [message]="popupMessage" (close)="resetMessageModal()"></popup-message>

<div *ngIf="loading">
    <spinner></spinner>
</div>
